"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _authentication = _interopRequireDefault(require("../../authentication"));

var _authenticationHelpers = require("../../authentication/authenticationHelpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

/* eslint-disable no-undef */
const TOKEN_KEY = 'access_token';
const ID_TOKEN_KEY = 'id_token';
const REFRESH_TOKEN = 'refresh_token';
const LOGIN_CONTEXT = 'login_context';
const TOKEN_EXPIRED_AT = 'token_expired_at';
const defaultState = {
  token: null,
  tokenExpiredAt: null,
  idToken: null,
  refreshToken: null,
  isRefreshingToken: false,
  loginContext: null,
  displayName: null,
  authenticationClient: null,
  oidcClientId: null,
  authCallbackUrl: null
};
const getters = {
  authCallbackUrl: state => state.authCallbackUrl,
  oidcClientId: state => state.oidcClientId,
  token: state => state.token || localStorage.getItem(TOKEN_KEY),
  idToken: state => state.idToken || localStorage.getItem(ID_TOKEN_KEY),
  tokenExpiredAt: state => state.tokenExpiredAt || localStorage.getItem(TOKEN_EXPIRED_AT),
  refreshToken: state => state.refreshToken || localStorage.getItem(REFRESH_TOKEN),
  isRefreshingToken: state => state.isRefreshingToken,
  loginContext: state => state.loginContext || JSON.parse(localStorage.getItem(LOGIN_CONTEXT)),
  displayName: state => state.displayName || localStorage.getItem('display_name'),
  // eslint-disable-next-line no-shadow
  authenticationClient: state => ({
    dispatch,
    getters
  }) => {
    if (state.authenticationClient === null) {
      const authentication = (0, _authentication.default)({
        dispatch,
        getters
      });
      const {
        authenticationFailureInterceptor
      } = authentication;

      const authenticationClient = _axios.default.create({
        baseURL: process.env.VUE_APP_AUTHENTICATION_BASE_URL,
        timeout: process.env.VUE_APP_HTTP_REQUEST_TIMEOUT
      });

      authenticationClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      state.authenticationClient = authenticationClient;
    }

    return state.authenticationClient;
  }
};
const actions = {
  setOidcClientId(context, oidcClientId) {
    context.commit('setOidcClientId', oidcClientId);
  },

  setAuthCallbackUrl(context, authCallbackUrl) {
    context.commit('setAuthCallbackUrl', authCallbackUrl);
  },

  async exchangeCodeForToken(context, payload) {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    try {
      const authenticationClient = context.getters.authenticationClient(context);
      const {
        data
      } = await authenticationClient.post('/oauth2/token', _qs.default.stringify(payload), config);
      const tokenExpiredAt = (0, _authenticationHelpers.getTokenExpirationFromDuration)(data.expires_in * 1000);
      localStorage.setItem(TOKEN_KEY, data.access_token);
      localStorage.setItem(ID_TOKEN_KEY, data.id_token);
      localStorage.setItem(REFRESH_TOKEN, data.refresh_token);
      localStorage.setItem(TOKEN_EXPIRED_AT, tokenExpiredAt);
      context.commit('setToken', data.access_token);
      context.commit('setIdToken', data.id_token);
      context.commit('setRefreshToken', data.refresh_token);
      context.commit('setTokenExpiredAt', tokenExpiredAt);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      throw error;
    }
  },

  async refreshToken(context, {
    redirectTo
  } = {}) {
    const refreshToken = context.rootGetters['authentication/refreshToken'];
    if (context.rootGetters['authentication/isRefreshingToken'] || !refreshToken) return;
    context.commit('setIsRefreshingToken', true);
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    try {
      const authenticationClient = context.getters.authenticationClient(context);
      const {
        data
      } = await authenticationClient.post('/oauth2/token', _qs.default.stringify({
        refresh_token: refreshToken,
        grant_type: 'refresh_token',
        redirect_uri: context.rootGetters['authentication/authCallbackUrl'] || context.rootGetters['bookingChannel/authCallbackUrl'],
        client_id: context.rootGetters['authentication/oidcClientId'] || context.rootGetters['bookingChannel/oidcClientId']
      }), config); // transform from s to ms

      const tokenExpiredAt = (0, _authenticationHelpers.getTokenExpirationFromDuration)(data.expires_in * 1000);
      localStorage.setItem(TOKEN_KEY, data.access_token);
      localStorage.setItem(ID_TOKEN_KEY, data.id_token);
      localStorage.setItem(REFRESH_TOKEN, data.refresh_token);
      localStorage.setItem(TOKEN_EXPIRED_AT, tokenExpiredAt);
      context.commit('setToken', data.access_token);
      context.commit('setIdToken', data.id_token);
      context.commit('setRefreshToken', data.refresh_token);
      context.commit('setTokenExpiredAt', tokenExpiredAt);
      if (redirectTo) window.location.replace(redirectTo);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    context.commit('setIsRefreshingToken', false);
  },

  async setLoginContext(context, loginContext) {
    localStorage.setItem(LOGIN_CONTEXT, JSON.stringify(loginContext));
    context.commit('setLoginContext', loginContext);
  },

  async clearToken(context) {
    localStorage.removeItem(TOKEN_KEY);
    context.commit('setToken', null);
  },

  async clearTokens() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(ID_TOKEN_KEY);
  },

  async clearLoginContext(context) {
    localStorage.removeItem(LOGIN_CONTEXT);
    context.commit('setLoginContext', null);
  },

  async revokeToken(context, payload) {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    try {
      const authenticationClient = context.getters.authenticationClient(context);
      await authenticationClient.post('/oauth2/revoke', _qs.default.stringify(payload), config);
      localStorage.removeItem(TOKEN_KEY); // TODO handle properly with id_token

      localStorage.removeItem('display_name');
      context.commit('setToken', null);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch('globalError/addError', {
        message: 'authentication.tokenRevocationError'
      }, {
        root: true
      });
    }
  },

  async setDisplayName(context) {
    // Todo handle with id token
    if (context.rootGetters['userProfile/user'].givenName && context.rootGetters['userProfile/user'].familyName) {
      const displayName = `${context.rootGetters['userProfile/user'].givenName} ${context.rootGetters['userProfile/user'].familyName}`;
      localStorage.setItem('display_name', displayName);
      context.commit('setDisplayName', displayName);
    }
  }

};
const mutations = {
  setOidcClientId(state, oidcClientId) {
    state.oidcClientId = oidcClientId;
  },

  setAuthCallbackUrl(state, authCallbackUrl) {
    state.authCallbackUrl = authCallbackUrl;
  },

  setToken(state, token) {
    state.token = token;
  },

  setIdToken(state, idToken) {
    state.idToken = idToken;
  },

  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken;
  },

  setIsRefreshingToken(state, isRefreshingToken) {
    state.isRefreshingToken = isRefreshingToken;
  },

  setTokenExpiredAt(state, tokenExpiredAt) {
    state.tokenExpiredAt = tokenExpiredAt;
  },

  setLoginContext(state, loginContext) {
    state.loginContext = loginContext;
  },

  setDisplayName(state, displayName) {
    state.displayName = displayName;
  }

};
var _default = {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations
};
exports.default = _default;